import './index.scss'
import React from 'react'
import Base from '../base'

export default class JustText extends Base {
  render() {
    return (
      <div className="section-collection-articles articles-layout-just-text">
        <div className="container">
          {this.state.articles.map((article, index) =>
            <div className="collection-article-item" key={"article-" + article.guid + index}>
              <div className="collection-article-info">
                <a href={article.path || ""}>{article.title}</a>
              </div>
            </div>
          )}

          {super.render()}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/app/site/structures/section/collection/articles/just-text/index.js